// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u9Qs","type":"styles_type__MUKiU","choices":"styles_choices__3KJeW"};